import IDAustriaButton from './IDAustriaButton';
import { useAppTranslation } from '../../../i18n';
import { Header } from '../blank-check-input-step/Header';
import BankIdent from './BankIdent';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

export const BankAuthTypeSelection = () => {
	const { t } = useAppTranslation();

	return (
		<div id="bank-auth-type-step" className="bank-auth-type-selection-step -ml- flex flex-col items-start gap-5">
			<div className="mb-5 -my-8 custom-small:-ml-5">
				<Header />
			</div>

			<div className="flex items-start gap-1 flex-col ml-2 mb-5">
				<p
					role="heading"
					aria-level={2}
					style={{
						fontWeight: '700',
						WebkitTextStroke: '0.2px currentColor'
					}}
					className=""
				>
					{t(`${TRANSLATION_PREFIX}.selection-title`)}
				</p>
				<p className="whitespace-pre-line italic font-[500] text-sm">
					{t(`${TRANSLATION_PREFIX}.selection-description`)}
				</p>
			</div>

			<IDAustriaButton />

			<div className="flex items-center gap-3 w-full">
				<div className="w-full bg-gray-300 h-[1px]" />
				<p className="text-sm">{t(`${TRANSLATION_PREFIX}.bank-auth-type-or`)}</p>
				<div className="w-full bg-gray-300 h-[1px]" />
			</div>

			<BankIdent />
		</div>
	);
};

export default BankAuthTypeSelection;
